// extracted by mini-css-extract-plugin
export default {"transfer-in__container":"styles_transfer-in__container__TYqVV","title":"styles_title__67D89"};